"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dateHelper = require("../../../helpers/dateHelper");
var _table = require("../../data/table");
var _CancelAPButton = _interopRequireDefault(require("../../common/CancelAPButton"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('order-history-table');
var WithdrawStatusComponent = function WithdrawStatusComponent(props) {
  var t = props.t,
    data = props.data,
    decimalPlaces = props.decimalPlaces,
    config = props.config,
    cancelWithdrawTicket = props.cancelWithdrawTicket,
    selectedAccountId = props.selectedAccountId,
    getWithdrawTickets = props.getWithdrawTickets,
    OMSId = props.OMSId,
    fetching = props.fetching;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  (0, _react.useEffect)(function () {
    getWithdrawTickets(selectedAccountId, OMSId, 0);
  }, [selectedAccountId, getWithdrawTickets, OMSId, maxLines]);
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Product'),
      dataTest: 'Product',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref) {
        var row = _ref.row;
        return row.original.AssetName;
      }
    }, {
      header: t('Amount'),
      dataTest: 'Amount',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return (0, _numberFormatter.formatNumberToLocale)(row.original.Amount, decimalPlaces[row.original.AssetId]);
      }
    }, {
      header: t('Status'),
      dataTest: 'Status',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return t(row.original.Status);
      }
    }, {
      header: t('Transaction Id'),
      dataTest: 'Transaction Id',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return row.original.TicketNumber;
      }
    }, {
      header: t('Wallet Address'),
      dataTest: 'Wallet Address',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        var addr = '-';
        try {
          var _data = JSON.parse(row.original.WithdrawTransactionDetails);
          if (_data.ExternalAddress) {
            addr = _data.ExternalAddress;
          }
        } catch (e) {
          //
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "address"
        }, addr);
      }
    }, {
      header: t('Created'),
      dataTest: 'Created',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return (0, _dateHelper.formatDateTime)(row.original.CreatedTimestamp);
      }
    }, {
      header: t('Fee'),
      dataTest: 'Fee',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return row.original.FeeAmt;
      }
    }, {
      header: t('Actions'),
      dataTest: 'Actions',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref8) {
        var row = _ref8.row;
        return ['Pending', 'Pending2Fa'].includes(row.original.Status) ? /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
          customClass: baseClass(),
          text: t('Cancel'),
          onClick: function onClick() {
            return cancelWithdrawTicket(row.original);
          }
        }) : '';
      }
    }];
  }, [t, decimalPlaces, cancelWithdrawTicket]);
  return /*#__PURE__*/_react["default"].createElement(_table.Table, {
    className: baseClass(),
    columns: columns,
    data: data,
    stickyColumns: {
      right: ['Actions']
    },
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
  });
};
WithdrawStatusComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  decimalPlaces: _propTypes["default"].object.isRequired,
  config: _propTypes["default"].object.isRequired,
  cancelWithdrawTicket: _propTypes["default"].func.isRequired,
  selectedAccountId: _propTypes["default"].string.isRequired,
  getWithdrawTickets: _propTypes["default"].func.isRequired,
  OMSId: _propTypes["default"].number.isRequired
};
var WithdrawStatusTranslated = (0, _reactI18next.withTranslation)('order')(WithdrawStatusComponent);
// t('Withdraw Status');
WithdrawStatusTranslated.title = 'Withdraw Status';
var _default = exports["default"] = WithdrawStatusTranslated;